import { __module as interopRequireDefault } from '../../../../_virtual/interopRequireDefault.js';

(function (module) {
	function _interopRequireDefault(e) {
	  return e && e.__esModule ? e : {
	    "default": e
	  };
	}
	module.exports = _interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;
} (interopRequireDefault));
//# sourceMappingURL=interopRequireDefault.js.map
